__turbopack_context__.v({
  "grid": "style-module-scss-module__WXZh5G__grid",
  "section": "style-module-scss-module__WXZh5G__section",
  "titleWrapper": "style-module-scss-module__WXZh5G__titleWrapper",
});
